var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPersonalBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 319,
    height: 268,
    viewBox: "0 0 319 268",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M317.542 151.71C298.931 150.757 183.859 157.88 160 172.741C123.906 195.225 73.1718 217.906 3.97199 204.698",
    stroke: "#B7B04F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M317.587 98.0293C288.226 98.036 228.498 116.562 201.471 137.369C174.445 158.176 163.816 163.558 151.965 168.751C123.591 181.183 81.2392 197.103 3.97175 200.963",
    stroke: "#B7B04F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M315.839 31.7539C280.459 34.7117 219.838 64.8767 200.024 94.7322C180.211 124.588 170.701 132.676 159.602 140.64C133.031 159.706 91.7509 184.726 1.00015 197.522",
    stroke: "#B7B04F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonalBg);
export default __webpack_public_path__ + "static/media/personal-bg.cc9793d6260524292ea00aa8501d7391.svg";
export { ForwardRef as ReactComponent };